export let ServiceTemplateStatus = /*#__PURE__*/function (ServiceTemplateStatus) {
  ServiceTemplateStatus["Active"] = "active";
  ServiceTemplateStatus["Deleted"] = "deleted";
  return ServiceTemplateStatus;
}({});